if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"core_my_number","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(3(07|561|985)|47(|2)9|(568|739|885)9|(60|75)91|1222|6587|9427|9980)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}